import React from 'react';
import { Typography } from '@mui/material';
import { IconCustom } from '../IconCustom/IconCustom';

interface BadgeEventTitleProps {
  eventType: string;
  eventTitle: string;
  seriesId?: number; //optional
}

export const BadgeEventTitle: React.FC<BadgeEventTitleProps> = ({ eventType, eventTitle, seriesId = 0 }) => {
  // The blocked events have no eventType, so we need to set it to 'Blocked'
  const modifiedEventType = eventType === null ? 'Blocked' : eventType;

  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <IconCustom
        type={modifiedEventType}
      />
      {eventTitle}
      {seriesId !== 0 && (
        <IconCustom
          type="Series"
        />
      )}
    </div>
  );
}; 